import { types } from '../../types/types';

const initialState = {
    loadingActionScreen: false,
    msgLoadingActionScreen: ""
}


export const uiReducer = (state = initialState, action) => {

    switch (action.type) {

        case types.uiLoadingActionScreen:
            return {
                ...state,
                loadingActionScreen: action.payload
            }

        case types.uiSetMsgActionScreen:
            return {
                ...state,
                msgLoadingActionScreen: action.payload
            }

        case types.uiStartLoadingScreen:
            return {
                ...state,
                loadingActionScreen: true
            }

        case types.uiFinishLoadingScreen:
            return {
                ...state,
                loadingActionScreen: false
            }

        default:
            return state;
    }

}